






































































	import {Component, Vue} from 'vue-property-decorator';
	import SectionTitle from "@/components/SectionTitle.vue";
	import Cardo from "@/components/HestiaCard.vue";
	import {HashLink} from "@/router/navigation";
	import GmSection from "@/components/GmSection.vue";

	@Component({components: {Cardo, SectionTitle, GmSection}})
	export default class Overview extends Vue {
		get sectionId() {return HashLink.srvOverview}
	}
